import { z } from 'zod';
import { HealixGender } from '../../enums';

export const ReferralHealixPatientGenderSchema = z
  .enum(
    HealixGender,
    `Patient gender should be one of: ${Object.values(HealixGender).join(', ')}`,
  )
  .optional();
